import { useAuth0 } from '@auth0/auth0-react';
import { Button, Stack, Typography, styled } from '@mui/material';
import { ElementType } from 'react';
import { QuoidenLogo } from '~/assets/logos';
import { theme } from '~/shared/styles/theme';

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Container component="main">
      <Stack alignItems="flex-end" pt={8} pr={12}>
        <SignInButton
          onClick={() =>
            loginWithRedirect({ authorizationParams: { screen_hint: 'login' } })
          }
        >
          Sign In
        </SignInButton>
      </Stack>
      <LogoContainer>
        <QuoidenLogo />
        <CopyContainer>
          <Copy>
            Build your family tree to find health conditions passed down in
            families like OTC deficiency.
          </Copy>
          <CreateAccountButton
            variant="outlined"
            onClick={() =>
              loginWithRedirect({
                authorizationParams: { screen_hint: 'signup' },
              })
            }
          >
            <Typography fontSize="18px" fontWeight={500}>
              Create Account
            </Typography>
          </CreateAccountButton>
        </CopyContainer>
      </LogoContainer>
    </Container>
  );
};

export default LoginPage;

const Container = styled(Stack)<{ component?: ElementType }>({
  flexDirection: 'column',
  height: '100vh',
  backgroundColor: theme.palette.custom.cream,
});

const LogoContainer = styled(Stack)({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const CopyContainer = styled(Stack)({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(6),
});

const Copy = styled(Typography)({
  textAlign: 'center',
  color: theme.palette.custom.mediumBrown,
  fontWeight: 500,
  maxWidth: 300,
});

const SignInButton = styled(Button)({
  fontSize: '18px',
  width: '144px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.custom.green,
  color: theme.palette.common.white,
  borderRadius: theme.tokens.borderRadius.full,
});

const CreateAccountButton = styled(Button)({
  fontSize: '18px',
  height: '52px',
  width: '286px',
  backgroundColor: theme.palette.common.white,
  borderColor: theme.palette.custom.lightGrayBrown,
  borderRadius: theme.tokens.borderRadius.full,
  color: theme.palette.custom.textMain,
  maxWidth: '286px',
});
